import useFetch from "../services/apiService/useFetch";
import API_ENDPOINTS from "../consts/endpoint";
import { getActiveBrandConfig } from "../theme/brands";
import {
  API_RESPONSE_STATUS_CODE,
  SESSION_TYPE_STRING,
  SPARKL,
} from "../consts/constants";
import { appendRefUrlParam } from "../utils/refUrl";

interface JoinTestParams {
  sessionId: number;
  sessionType: string;
}

const getDomainForSessionType = (sessionType: string): string => {
  const domains = {
    [SESSION_TYPE_STRING.PROCTOR_TEST]:
      process.env.REACT_APP_LIVE_CLASS_PORTAL || SPARKL.liveClassPortal,
    [SESSION_TYPE_STRING.NON_PROCTOR_TEST]:
      process.env.REACT_APP_VELOCITY_PORTAL || SPARKL.nonProctorPortal,
  };
  return domains[sessionType] || "";
};

const getParamsForSessionType = (
  sessionType: string,
  token: string
): URLSearchParams => {
  if (sessionType === SESSION_TYPE_STRING.PROCTOR_TEST) {
    const params = new URLSearchParams();
    params.set('sso', token);
    params.set('sessionType', SESSION_TYPE_STRING.PROCTOR_TEST);
    params.set('type', '4'); // PROCTORED_TEST code
    return params;
  }
  // For non-proctor test
  const params = new URLSearchParams();
  params.set('sso', token);
  params.set('bu_id', String(getActiveBrandConfig().buId));
  return params;
};

const constructTestUrl = (
  domain: string,
  sessionId: number,
  params: URLSearchParams
): string => {
  const baseUrl = `${domain}/sso/${sessionId}`;
  return appendRefUrlParam(`${baseUrl}?${params.toString()}`);
};

const useJoinTest = () => {
  const { data, fetchData, isLoading } = useFetch({
    url: API_ENDPOINTS.SSO_LOGIN_TOKEN,
    otherOptions: { skipApiCallOnMount: true },
  });

  const handleJoinTest = async ({ sessionId, sessionType }: JoinTestParams) => {
    const res = await fetchData();
    if (res.status === API_RESPONSE_STATUS_CODE.SUCCESS) {
      const domain = getDomainForSessionType(sessionType);
      const params = getParamsForSessionType(sessionType, res.data.token);
      const fullUrl = constructTestUrl(domain, sessionId, params);

      console.log("Opening URL:", fullUrl);
      window.open(fullUrl);
    }
  };

  return { data, handleJoinTest, isLoading };
};

export default useJoinTest;
